import React from "react";
import { MarketingLayout } from "../../components/enterprise2/MarketingLayout";
import { TwoCol } from "../../components/enterprise2/TwoCol";

export default function Research() {
  return (
    <MarketingLayout
      active="research"
      title="Research. Crowther."
      description="Applied research on entity resolution, reasoning over knowledge graphs, and specialist model performance."
    >
      <TwoCol
        as="h1"
        id="e2-research"
        label="Research"
        title="What we are learning."
        lede="Applied, not academic. We share what we have tested and can stand behind."
      >
        <div className="e2-rows">
          <div className="e2-row" data-testid="e2-research-benchmark">
            <div className="e2-row-name">DeepResearch Bench</div>
            <div>
              <div className="e2-row-desc">
                An agent built on Atom placed second overall on DeepResearch Bench, scoring 53.70, and first on insight at 57.2, ahead of Gemini 2.5 Pro.
              </div>
              <div className="e2-meta" style={{ marginTop: 8 }}>Benchmark result</div>
            </div>
          </div>
        </div>
        <p className="e2-body" style={{ marginTop: 40, maxWidth: "60ch" }}>
          Our durable technical focus is entity resolution and reasoning over knowledge graphs. Retrieval finds documents that mention a name; resolution reveals the single entity behind them, and reasoning runs over the relationships between resolved entities. The work that follows lives inside that surface.
        </p>
      </TwoCol>
    </MarketingLayout>
  );
}
